module.exports = __webpack_public_path__ + "img/trust.e519987a.png";